export default "__VITE_ASSET__oCEyJ0fs__";